import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M29 27.218c0-.898-.391-1.769-1.167-2.22C25.681 23.743 22.66 23 20 23s-5.68.744-7.833 1.997C11.39 25.45 11 26.32 11 27.218V31h18v-3.782ZM27 29v-1.782a.855.855 0 0 0-.079-.378c-.038-.075-.073-.102-.094-.114C25.017 25.672 22.352 25 20 25c-2.352 0-5.017.672-6.827 1.726a.258.258 0 0 0-.094.114.855.855 0 0 0-.079.378V29h14Zm-2-12a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.574 6.861a6.542 6.542 0 0 1 11.045.36l.459.779H34v28H6V8h7.799l.775-1.139ZM19.982 6c-1.503 0-2.91.744-3.755 1.987l-.898 1.32a1.585 1.585 0 0 1-1.31.693H8v24h24V10h-6.197a1.52 1.52 0 0 1-1.31-.748l-.598-1.016A4.542 4.542 0 0 0 19.982 6Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramB2BFindRealtor40 = createIcon(IconComponent);